module.exports = __webpack_public_path__ + "img/9a345a9.jpg";